import React from "react";
import { Link } from "react-router-dom";
import { ENV } from "@/config/env";

const Footer = () => {
  return (
    <footer className="bg-surface-container pt-32 pb-16">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-[60px]">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 lg:gap-12 mb-32">
          {/* Column 1 - Brand Editorial */}
          <div className="space-y-10">
            <h2 className="text-[28px] font-display text-primary italic leading-tight">
              Subrahmanya Rudraksha
            </h2>
            <p className="text-on-surface-variant text-base font-body font-light leading-relaxed max-w-[280px]">
              Divine, Lab-Certified, and Authentic Rudraksha beads sourced directly from the holy Himalayas of Nepal.
            </p>
          </div>

          {/* Column 2 - Links Labels */}
          <div className="space-y-10">
            <h3 className="text-[11px] font-body font-bold tracking-[0.3em] uppercase text-on-surface-variant/40">
              Navigation
            </h3>
            <ul className="space-y-5">
              <li>
                <Link to="/" className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300">
                  The Sanctuary Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300">
                  Our Spiritual Origin
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300">
                  Connect With Us
                </Link>
              </li>
              <li>
                <a
                  href={ENV.BLOG_URL}
                  // target="_blank"
                  // rel="noopener noreferrer"
                  className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300"
                >
                  Divine Wisdom (Blogs)
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Wisdom Links */}
          <div className="space-y-10">
            <h3 className="text-[11px] font-body font-bold tracking-[0.3em] uppercase text-on-surface-variant/40">
              Essence
            </h3>
            <ul className="space-y-5">
              <li>
                <Link to="/privacy-policy" className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300">
                  Privacy Rituals
                </Link>
              </li>
              <li>
                <Link to="/terms-of-use" className="text-on-surface text-sm font-body font-light hover:text-primary transition-all duration-300">
                  Sacred Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4 - Connection */}
          <div className="space-y-10">
            <h3 className="text-[11px] font-body font-bold tracking-[0.3em] uppercase text-on-surface-variant/40">
              Divine Presence
            </h3>
            <ul className="space-y-5 font-body">
              <li>
                <a href="#!" className="text-on-surface text-sm font-light hover:text-primary transition-all duration-300">
                  Instagram Presence
                </a>
              </li>
              <li>
                <a href="https://wa.me/918750122331" className="text-on-surface text-sm font-light hover:text-primary transition-all duration-300">
                  WhatsApp Support
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Editorial Quote & Legal */}
        <div className="pt-20 flex flex-col md:flex-row justify-between items-center gap-8 border-t border-outline-variant/10">
          <p className="text-[11px] text-on-surface-variant/50 tracking-[0.2em] font-body uppercase">
            © Subrahmanya Rudraksha 2026. Crafted for the Modern Seeker.
          </p>
          <div className="flex gap-10">
            <span className="text-[11px] text-primary/30 font-display italic tracking-widest uppercase">
              Authenticated & Sacred
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
